import React, { useState, useEffect } from "react";
import {
  Alert,
  Box,
  Button, InputLabel, TextField
} from "@mui/material";
import { addAccount, returnAddAccountIsAvailable } from "./AccountUtil";
import { useDispatch } from "react-redux";
import { GetAccountList } from "../Header/HeaderUtils";
import { pushAccounts } from "../../routes/appRoutes";



const NewAccount = () => {
  const dispatch = useDispatch();

  const [isAddAccountIsAvailable, setIsAddAccountIsAvailable] = useState(false);
  const [accountName, setAccountName] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [errorCode, setErrorCode] = useState<string | null>(null);

  useEffect(() => {
    fetchData();
  }, []);

  const addNewAccount = async () => {
    setError(null);
    setErrorCode(null);
    const result = await addAccount(dispatch, accountName);
    
    if (result.success) {
      setIsSuccess(true);
      setAccountName("");
      fetchData();
      getAccounts();
    } else {
      console.log("Add account error:", result);
      setError(result.error);
      setErrorCode(result.code);
    }
  };

  const getAccounts = async () => {
    const accounts = await GetAccountList(dispatch);
    pushAccounts(accounts);
  };

  const fetchData = async () => {
    setIsAddAccountIsAvailable(
      await returnAddAccountIsAvailable(dispatch)
    );
  }

  const onchangeInput = (event) => {
    setAccountName(event.target.value);
    // Clear error when user starts typing
    if (error) {
      setError(null);
      setErrorCode(null);
    }
  };

  const getErrorMessage = () => {
    console.log("Error code:", errorCode);
    console.log("Error message:", error);
    if (error === "account_name_already_exists") {
      return "This account name is already in use. Please choose a different name.";
    }
    return error || null;
  };

  return (
    <Box sx={{ paddingTop: "15px", width: "620px" }}>
      <h2>Add new account</h2>
      {isAddAccountIsAvailable && (
        <Box sx={{ width: "250px" }}>
          <InputLabel>Account Name</InputLabel>
          <TextField 
            id="account_name" 
            label="" 
            size="small"
            variant="outlined" 
            onChange={onchangeInput}
            value={accountName}
            error={!!error}
            helperText={error}
          />

          {getErrorMessage() && (
            <Alert severity="error" sx={{ mt: 2, mb: 2 }}>
              {getErrorMessage()}
            </Alert>
          )}

          <Button
            type="submit"
            sx={{ marginTop: 2 }}
            className="blue-btn"
            disabled={accountName === ''}
            onClick={addNewAccount}
          >
            Add
          </Button>
        </Box>
      )}
      {!isAddAccountIsAvailable && !isSuccess &&
        <p>You cannot add a new account because there is an existing inactive account</p>}
      {isSuccess && <Alert severity="success" onClose={() => setIsSuccess(false)} sx={{ mt: 3 }}>The account was successfully added!</Alert>}
    </Box>
  );
};
export default NewAccount;